import { NAV } from "../lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-maroon-deep text-cream/80">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid place-items-center h-11 w-11 rounded-full border border-saffron/50 text-saffron">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7.5 4.5 C7.5 12, 9 15, 12 16 C15 15, 16.5 12, 16.5 4.5" />
                <path d="M12 8.5 L12 16" />
                <path d="M12 5 C10.6 6.4, 10.6 8, 12 9 C13.4 8, 13.4 6.4, 12 5 Z" fill="currentColor" stroke="none" />
              </svg>
            </span>
            <div>
              <div className="ff-display text-xl text-cream">Bhakti Svarup</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-saffron">Vidya Niketan</div>
            </div>
          </div>
          <p className="mt-5 font-light max-w-xs leading-relaxed">
            An institution where ancient wisdom and modern learning are raised as one.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-saffron mb-5">Explore</div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="font-light hover:text-cream transition-colors">
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-saffron mb-5">Reach Us</div>
          <p className="font-light leading-relaxed">
            Kotpad, Koraput,<br />
            Odisha<br />
            +91 70086 46951<br />
            bsvnschool7@gmail.com
          </p>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-3 text-xs tracking-wide text-cream/50">
        <span>© {new Date().getFullYear()} Bhakti Svarup Vidya Niketan. All rights reserved.</span>
        <span className="ff-display italic text-saffron/80 text-sm">Vidya dadaati vinayam — Knowledge bestows humility.</span>
      </div>
    </div>
  </footer>
);
